import { EventBus } from '../../../core/shared/helpers/EventHelper';
import ItemComponent from '../../../core/infraestructure/ItemComponent';

import SimulatorStudentDetailViewModel from '../../../core/features/simulator/viewmodels/SimulatorStudentDetailViewModel';

export default {
    extends: ItemComponent,
    data() {
        return {
            viewModel: null,
            currentTimer: null,
            timerLabel: null,
            sectionSelected: null,
            simulator: null,
            isFinished: false,
            isLoading: true,
            isTimerLoading: false,
            // Nombres de las secciones ya respondidas por el estudiante.
            // El simulador temporal no persiste el estado de la sección,
            // así que se lleva el control en memoria durante la sesión.
            finishedSections: [],
        };
    },
    mounted() {
        // this.$root.$on('onSubmitedSimulator', this.onSubmitSimulator)
        EventBus.$on('onFinishSection', this.onFinishSection);
    },
    beforeDestroy() {
        // this.$root.$off('onSubmitedSimulator', this.onSubmitSimulator);
        EventBus.$off('onFinishSection', this.onFinishSection);
    },
    created() {
        this.viewModel = new SimulatorStudentDetailViewModel(this);
        this.onActive();
    },
    watch: {
        // El nivel de navegación se refleja en la URL (?seccion=N) para que el
        // botón "atrás" del navegador retroceda un nivel en la jerarquía
        // (sección → detalle del simulador) en lugar de volver a la raíz.
        '$route.query.seccion'() {
            this.onSyncSectionFromRoute();
        },
    },
    methods: {
        onActive() {
            this.viewModel.onBindFormView(this.$route.params.id)
        },
        onFindSimulatorTemporalResponse(response) {
            if (response.data) {
                setTimeout(() => {
                    this.simulator = response.data;
                    // Si la URL ya traía una sección (recarga o enlace directo),
                    // se abre al terminar de cargar el simulador.
                    this.onSyncSectionFromRoute();
                }, 400);

                setTimeout(() => {
                    this.isLoading = false
                }, 400);
            } else {
                this.onSimulatorNotFound()
            }
        },
        onSelectSection(section) {
            if (this.viewModel.isSectionSelectable(this.simulator.isTimer, this.currentTimer)) {
                this.isLoading = true
                this.onOpenSection(section, this.getSectionIndex(section));

                setTimeout(() => {
                    this.isLoading = false
                }, 450);
            } else {
                this.$notify({
                    title: 'Advertencia',
                    message: 'Debe iniciar el simulador para poder seleccionar una sección',
                    type: 'warning'
                });
            }
        },
        onSubmitSimulator(data) {

        },
        onStartTimer() {
            this.isTimerLoading = true

            setTimeout(() => {
                this.currentTimer = this.viewModel.initTimer({
                    startValues: { minutes: this.viewModel.getTime(this.simulator) },
                    onStart: this.onTimerStart,
                    onUpdate: this.onTimerUpdate,
                    onFinished: this.onTimerFinished
                });
                this.isTimerLoading = false
            }, 600);
        },
        onTimerStart(data) {
            this.timerLabel = data
        },
        onTimerUpdate(data) {
            this.timerLabel = data
        },
        onTimerFinished() {
            this.timerLabel = null
            this.isFinished = true
            this.onCloseSection()
        },
        onFinishSection(sectionName) {
            this.isLoading = true
            if (sectionName && !this.finishedSections.includes(sectionName)) {
                this.finishedSections.push(sectionName);
            }
            setTimeout(() => {
                this.onCloseSection()
            }, 400);

            setTimeout(() => {
                this.isLoading = false
            }, 450);
        },
        onFinishSimulator() {
            this.$confirm(`Revisa tus respuestas, puede que falte alguna. Una vez que veas los resultados, no podrás comenzar nuevamente. ¿Deseas continuar?`, 'Alerta', {
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'No',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                confirmButtonClass: 'btn-primary',
                cancelButtonClass: 'btn-cancel',
                showCancelButton: true,
            }).then(() => {
                if (this.currentTimer) {
                    this.currentTimer.stop();
                }
                this.timerLabel = null
                this.isFinished = true
                this.onCloseSection()
            }).catch((error) => {

            });

        },
        // --- Navegación jerárquica: sección → detalle del simulador → inicio ---
        getSectionIndex(section) {
            const sections = this.simulator && this.simulator.simulatorSections
                ? this.simulator.simulatorSections
                : [];
            const index = sections.findIndex(item => item && item.id === section.id);
            return index >= 0 ? index : sections.indexOf(section);
        },
        getSectionIndexFromRoute() {
            const query = this.$route.query || {};
            const raw = query.seccion;
            if (raw === undefined || raw === null || raw === '') return null;
            const index = parseInt(raw, 10);
            return isNaN(index) ? null : index;
        },
        buildRouteQuery(sectionIndex) {
            const query = { ...(this.$route.query || {}) };
            delete query.seccion;
            if (sectionIndex !== null && sectionIndex !== undefined) {
                query.seccion = String(sectionIndex);
            }
            return query;
        },
        onSyncSectionFromRoute() {
            const index = this.getSectionIndexFromRoute();
            if (index === null) {
                // Sin sección en la URL: el detalle vuelve a mostrar el resumen.
                if (this.sectionSelected) {
                    this.sectionSelected = null;
                }
                return;
            }
            if (this.sectionSelected && this.getSectionIndex(this.sectionSelected) === index) return;
            if (!this.simulator || !this.simulator.simulatorSections) return;
            const section = this.simulator.simulatorSections[index];
            if (!section) return;
            if (!this.viewModel.isSectionSelectable(this.simulator.isTimer, this.currentTimer)) {
                // La sección aún no puede abrirse (cronómetro sin iniciar):
                // se limpia la URL para no dejar un nivel inconsistente.
                this.onReplaceRouteQuery(null);
                return;
            }
            this.sectionSelected = section;
        },
        onOpenSection(section, index) {
            this.sectionSelected = section;
            // La sección queda registrada en el historial: "atrás" regresa al
            // detalle del simulador en vez de salir a la raíz.
            this.$router.push({
                path: this.$route.path,
                query: this.buildRouteQuery(index)
            });
        },
        onCloseSection() {
            this.sectionSelected = null;
            // `replace` evita dejar una entrada de historial que reabra la sección.
            this.onReplaceRouteQuery(null);
        },
        onReplaceRouteQuery(sectionIndex) {
            if (this.getSectionIndexFromRoute() === null && (sectionIndex === null || sectionIndex === undefined)) {
                return;
            }
            this.$router.replace({
                path: this.$route.path,
                query: this.buildRouteQuery(sectionIndex)
            });
        },
        onBack() {
            // Un nivel arriba: si hay una sección abierta se cierra y se
            // permanece en el detalle del simulador.
            if (this.sectionSelected) {
                this.onCloseSection();
                return;
            }
            this.$router.push('/estudiante/resumen');
        },
        onSimulatorNotFound() {
            this.$confirm(`Simulador no existente, vuelve a generar otro simulador de prueba.`, 'Alerta', {
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'No',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                confirmButtonClass: 'btn-primary',
                cancelButtonClass: 'btn-cancel',
                showCancelButton: false,
            }).then(() => {
                this.isLoading = true
                setTimeout(() => {
                    this.isLoading = false
                    this.simulatorResult = null
                }, 800);
                setTimeout(() => {
                    this.$router.push('/estudiante/resumen')
                }, 810);
            }).catch((error) => {

            });
        },
        isSectionFinished(section) {
            return !!section && this.finishedSections.includes(section.name);
        },
        allSectionFinished() {
            const sections = this.simulator && this.simulator.simulatorSections ? this.simulator.simulatorSections : [];
            if (!sections.length) return false;
            return sections.every(section => this.isSectionFinished(section));
        },
        // El nivel de dificultad viaja como el enum numérico DifficultyLevel
        // (1 = Fácil, 2 = Intermedio, 3 = Difícil).
        getDifficultyLabel(level) {
            const labels = { 1: 'Fácil', 2: 'Intermedio', 3: 'Difícil' };
            return labels[level] || 'Intermedio';
        }
    },
};